import { getMeetingShares, inviteShare, updateSharePermission, updateShareRemove } from "@/services/share";
import { MeetingSharesItem } from "@/types/share";
import { message } from "antd";
import { useState, useEffect } from "react";

const useGetSharerList = (shareId?: string) => {
  const [sharerList, setSharerList] = useState<MeetingSharesItem[]>([]);
  const fetchSharerList = async () => {
    if (!shareId) return;
    const res = await getMeetingShares(shareId);
    setSharerList(res);
  };

  const refreshSharerList = () => {
    fetchSharerList();
  };

  const removeShareMember = async (sharer: MeetingSharesItem) => {
    if (!shareId) return;
    try {
      await updateShareRemove({
        shareId,
        identityId: sharer.identityId,
      });
      const newSharerList = sharerList.filter(
        (_item) => sharer.identityId !== _item.identityId
      );
      setSharerList(newSharerList);
    } catch (error) {
      console.log('移除共享人失败');
      message.error('移除共享人失败，请稍后再试');
    }
  }

  const updateShareMenber = async (sharer: MeetingSharesItem) => {
    if (!shareId) return;
    try {
      await updateSharePermission({
        shareId,
        identityId: sharer.identityId,
        sharePermission: sharer.sharePermission,
      });
      const newSharerList = <MeetingSharesItem[]>[];
      sharerList.map((_item) => {
        if (_item.identityId === sharer.identityId) {
          _item.sharePermission = sharer.sharePermission;
        }
        newSharerList.push(_item);
      });
      setSharerList(newSharerList);
    } catch (error) {
      console.log('更新共享人失败');
      message.error('更新共享人失败，请稍后再试');
    }
  }

  const inviteMember = async (sharers: MeetingSharesItem[]): Promise<boolean> => {
    if (!shareId) return false;
    try {
      await inviteShare({
        shareId,
        identitySharePermissions: sharers.map((item) => {
          return {
            identityId: item.identityId,
            sharePermission: item.sharePermission,
          }
        }),
      });

      fetchSharerList();
      return true;
    } catch (error) {
      console.log('邀请成员失败');
      message.error('邀请成员失败，请稍后再试');
      return false;
    }
  }

  useEffect(() => {
    fetchSharerList();
  }, [shareId]);

  return {
    sharerList,
    removeShareMember,
    updateShareMenber,
    inviteMember,
    setSharerList,
    refreshSharerList,
  };
};

export default useGetSharerList;
